import { createFileRoute } from '@tanstack/react-router';
import {
  loadSimulationMessages,
  loadSimulationRenewalScreens,
  simulationPrivateRefinancingScreen,
} from '@/modules/simulation/route';
import { flowSearchSchema } from '@/shared/flow/define-flow';
import { lazyScreen } from '@/shared/screen/lazy-screen';

export const Route = createFileRoute('/_app/ccb/contratar/consignado-privado/refinanciamento/')({
  validateSearch: flowSearchSchema(),
  staticData: { screen: simulationPrivateRefinancingScreen },
  loader: () => loadSimulationMessages(),
  component: lazyScreen(loadSimulationRenewalScreens, 'PrivateRefinancingRouteScreen'),
});
